import { NavPositionContext } from "contexts";
import React, { useContext } from "react";
import Container from "react-bootstrap/Container";
import logo from "assets/images/hopeedulogo.png";
import Navbar from "react-bootstrap/Navbar";
import { Link, useLocation } from "react-router-dom";
import { URLPaths } from "utilities";
import { BsFillArrowRightCircleFill } from "react-icons/bs";
import "./Navigation.scss";
import { resetToggles } from "./MapNavigation";

/** Generating the MapNavigation bar for the Department Info Page */
/** This file can also be added with further authentification for administrative privilege */
export const edDepNavBarHeight = "6rem";

export function EdDepInfoNav(): JSX.Element {
  const { navPosition } = useContext(NavPositionContext);
  const location = useLocation();

  return (
      <Navbar
        bg="light"
        className="original-navbar"
        fixed={navPosition}
        style={{ height: edDepNavBarHeight }}
      >
        <EdImage />
        <Container>
          <div>
            {location.pathname === URLPaths.edDepInfo ? (
              <h1 className="navbar-title">Hope Education Department Information</h1>
            ) : (
              <h1 className="navbar-title">Department Information Admin Dashboard</h1>
            )}
          </div>
        </Container>
        {/* <RNavLinkArrow path={URLPaths.map}> </RNavLinkArrow> */}

        <ActionNavLink path={URLPaths.pictureWall} text="Touch To See Our Students, Faculty & Staff" />
        <ActionNavLink path={URLPaths.map} text="Touch To View Education Opportunities In Michigan" />

      </Navbar>
  );
}

type NavLinkProps = {
  path: string;
  children: React.ReactNode;
};

/* Arrow in top right of NavBar */

// function RNavLinkArrow({ path, children }: NavLinkProps): JSX.Element {
//   const { pathname } = useLocation();
//   return (
//     <Link to={path} id="right-nav-arrow">
//       {children}
//       <button
//         className={`nav-link-arrow-right  ${pathname === path ? "active" : ""}`}
//         onClick={() => resetToggles()}
//       >
//         <BsFillArrowRightCircleFill />
//       </button>
//       <p className="nextText-short">Map</p>
//     </Link>
//   );
// }

function EdImage(): JSX.Element {
  return <img className="edlogo" id="logo" alt="edu" src={logo} />;
}

type ActionNavLinkProps = {
  path: string;
  text: string;
};

function ActionNavLink({ path, text }: ActionNavLinkProps): JSX.Element {
  const { pathname } = useLocation();
  return (
    <Link to={path} className={`action-nav-link ${pathname === path ? "active" : ""}`}>
      <button className="action-button">{text}</button>
    </Link>
  );
}
